// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx","774":"framework"}[chunkId] || chunkId) + "-" + {"218":"672f349930ba6d96a121","691":"d20dae9318c8df89ea6f","712":"40d6b9944e725eeff4dd","774":"f320ef8e8bbed4586035","857":"767b97d9b830059c0d30"}[chunkId] + ".js";
};